import JikeYellowLogoIcon from '@/components/Icons/JikeYellowLogoIcon'
import { css } from '@emotion/react'
import {
	CollectOutlineIcon,
	DeleteOutlineIcon,
	LinkIcon,
	RepostIcon,
	StickStickIcon,
	StickUnstickIcon,
	UncollectOutlineIcon,
} from '@ruguoapp/jike-fe-icons'
import type { MenuItemData } from '../DropdownMenu/types'

export enum ActionMenu {
	COPY_LINK = 'COPY_LINK',
	PIN = 'PIN',
	UNPIN = 'UNPIN',
	COLLECT = 'COLLECT',
	UNCOLLECT = 'UNCOLLECT',
	TO_SELF_ONLY = 'TO_SELF_ONLY',
	TO_PUBLIC = 'TO_PUBLIC',
	EDIT_POST = 'EDIT_POST',
	DELETE = 'DELETE',
	REPOST = 'REPOST',
}

export const ACTION_MENU_LOCALE: Record<ActionMenu, MenuItemData> = {
	[ActionMenu.REPOST]: {
		icon: <RepostIcon />,
		title: '转发动态',
		id: ActionMenu.REPOST,
	},
	[ActionMenu.COPY_LINK]: {
		icon: <LinkIcon />,
		title: '复制链接',
		id: ActionMenu.COPY_LINK,
	},
	[ActionMenu.PIN]: {
		icon: <StickStickIcon />,
		title: '置顶',
		id: ActionMenu.PIN,
	},
	[ActionMenu.UNPIN]: {
		icon: <StickUnstickIcon />,
		title: '取消置顶',
		id: ActionMenu.UNPIN,
	},
	[ActionMenu.COLLECT]: {
		icon: <CollectOutlineIcon />,
		title: '收藏',
		id: ActionMenu.COLLECT,
	},
	[ActionMenu.UNCOLLECT]: {
		icon: <UncollectOutlineIcon />,
		title: '取消收藏',
		id: ActionMenu.UNCOLLECT,
	},
	[ActionMenu.TO_SELF_ONLY]: {
		icon: <JikeYellowLogoIcon />,
		title: '转为仅自己可见',
		id: ActionMenu.TO_SELF_ONLY,
	},
	[ActionMenu.TO_PUBLIC]: {
		icon: <JikeYellowLogoIcon />,
		title: '转为公开',
		id: ActionMenu.TO_PUBLIC,
	},
	[ActionMenu.EDIT_POST]: {
		icon: <JikeYellowLogoIcon />,
		title: '编辑动态',
		id: ActionMenu.EDIT_POST,
	},
	[ActionMenu.DELETE]: {
		icon: <DeleteOutlineIcon />,
		title: '删除',
		id: ActionMenu.DELETE,
		props: {
			css: css`
				color: var(--tint-error);
			`,
		},
	},
}
